import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid'
import moment from 'moment'
import _ from 'lodash'
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex', 
        flexDirection: 'column', 
        height: '600px'
    },
    iconButton: {
        marginLeft: theme.spacing(1)
    },
    batchTextField: {
        display: 'flex',
        paddingBottom: theme.spacing(2)
    }
}))

function SelectDispatchHistory(props){
    const {t} = useTranslation('common')
    let {data, isLoading} = props
    const classes = useStyles();

    const columns = [
        {field: 'long_name', headerName: t('creator'), flex: 1},
        {field: 'name', headerName: t('code_name'), width: 100},
        {field: 'create_time', headerName: t('date'), type: 'date', flex: 1,
            valueFormatter: (params)=> moment.unix(params.value).format("MMM DD, YYYY - HH:mm:ss")}
    ]

    const [rows, setRows] = useState([]);

    useEffect(() => {
        if(data.data) {
            setRows(data.data.data);
        }
    }, [data])

    return (
        <div className={classes.root}>
            <div style={{display: 'flex', height: '100%'}}>
                <div style={{flexGrow: 1}}>
                    <DataGrid 
                        columns={columns}
                        rows={rows}
                        sortModel={[{
                            field: "create_time",
                            sort: 'desc'
                        }]}
                        onSelectionModelChange={(newSelection) => {
                            let id = parseInt(_.first(newSelection))
                            props.saveHistoryId(id);
                            props.handleSelectedSlots(id);
                        }}
                        loading={isLoading}
                        autoPageSize
                        disableColumnFilter
                        disableColumnMenu
                        disableMultipleSelection={true}
                        autoHeight
                    />
                </div>
            </div>
        </div>
    )
}

export default React.memo(SelectDispatchHistory)